// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-flap-price":"split-flap-price___DSMnW","thousands":"thousands___fyjKr","millions":"millions___xziq4"};